import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const GuideStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),

    container: {
        ...OnboardingStyle(theme).container,
        boxSizing: 'border-box',
        minHeight: 'unset',
        flex:1,
    },

    formGuide: {
        ...OnboardingStyle(theme).form,
        gap: theme.spacing(3.75),
    },
    formController: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },

    // Children Step
    formMiddleContentChildren: {
        ...OnboardingStyle(theme).formMiddleContent,
        gap: theme.spacing(2),
    },

    // Template Step
    templateList: {
        margin: '30px 0px',
        display: 'flex',
        flexDirection: 'column',

        '& > .MuiTypography-root:first-child': {
            marginTop: 0,
        }
    },
    templateListLabel: {
        ...typography.label,
        margin: theme.spacing(3.75, 0, 2.5),
    },
    templateHelpInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
    },
    templateCalendar: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        alignItems: 'center',
        gap: '4px',
    },
    templateCalendarDayName: {
        ...typography.body1,
        fontSize: '0.5rem',
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    templateCalendarDay: {
        minWidth: '22px',
        minHeight: '22px',
        borderRadius: '2px',
        backgroundColor: styleColors.transparent,
    },
    templateCalendarDayLarge: {
        minWidth: '34px',
        minHeight: '38px',
        borderRadius: '4px',
        backgroundColor: theme.palette.common.white,
    },
    calendarTemplateLegend: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
    },
    calendarTemplateLegendItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
    },
    calendarTemplateLegendItemCircle: {
        width: '16px',
        height: '16px',
        borderRadius: '16px',
        backgroundColor: theme.palette.common.black,
    },
    inputStyle : {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '0.1875rem',
        border:`1px solid ${styleColors.black}`,
        color: styleColors.greyDark3,
        outline: 'none',
        padding: '12px',
        fontSize: '18px',
        letterSpacing: '0.5px',
        fontWeight: 600,
        backgroundColor: styleColors.white,
    },
    // Handover step
    handoverContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    handoverRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(1.5),
        flexWrap: 'nowrap',
        alignItems: 'center',
        boxSizing: 'border-box',
        minWidth: 0,
        width: '100%',

        '& > *': {
            minWidth: 0,
        },
    },

    // General guide styling
    default: {
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    slide: {
        left: -5000
    },
    flex_d_col: {
        flexDirection: 'column'
    },
    btn_mb5: {
        marginBottom: 5
    },
    margin_r8: {
        marginRight: 8
    },
    title: {
        fontSize: '25px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '16px',
    },
    mainText: {
        color: styleColors.greyDark1,
        margin: 0,
        fontSize: '16px',
        fontWeight: 500,
        paddingBottom: '30px',
        textAlign: 'center',
    },
    dropBox: {
        fontSize: '1rem',
        fontFamily: "'Metropolis', 'Helvetica', 'Arial', sans-serif",
        fontWeight: 400,
        width: 'fit-content',
        margin: '0px 8px',
        backgroundColor: styleColors.white,
        padding: 12,
        borderRadius: '6px',
    },
    // Handovercard styling

    customSelect: {
        maxWidth: 140,
        padding: '8px',
        borderRadius: '100px',
        borderColor: styleColors.greyMedium1,
        fontFamily: '"Metropolis", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        fontSize: '0.875rem',
        marginBottom: '8px',
        marginLeft: '8px',
        borderWidth: 0,
    },
    paragraph: {
        paddingLeft: 10,
        fontSize: 14.5,
        letterSpacing: .3,
        marginBottom: 20
    },
    flex_row: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    flex_row_wrap: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    svg_image: {
        width: 35,
        height: 35
    },
    completed_status: {
        transform: 'scale(1.3)',
    },
    handover_card1: {
        backgroundColor: styleColors.lightBeige,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        width: '100%',
        borderRadius: 20,
        marginBottom: 15,
        padding: '0 10px 12px 10px'
    },

    // StepStartDate

    padding_12px_24px: {
        padding: '12px 24px'
    },

    // StepAdjustDays

    direction_column1: {
        flexDirection: 'column',
        padding: '0 12px 8px 12px'
    },
    btn_mb8: {
        marginBottom: 8
    },
    btn_mr15_mb8: {
        marginRight: 15,
        marginBottom: 8
    },

    // StepChildren

    align_center1: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: styleColors.lightBeige,
        borderRadius: '20px',
        padding: '20px',
        width: '100%',
        boxSizing: 'border-box',
    },
    checkboxSpace: {
        backgroundColor: styleColors.white,
        borderRadius: '100px',
        padding: '4px 16px',
        marginBottom: '10px',
        minWidth: '200px',
        display: 'flex',
        justifyContent: 'center',
    },
    image: {
        width: '240px',
        marginLeft: 'auto',
        marginRight: 'auto',
        ['@media (min-width:576px)']: {
            width: '300px',
        },
        ['@media (min-width:1024px)']: {
            //  display: 'none'
        },
        '& img': {
            width: '100%',
            height: 'auto',
        }
    },

    // StepHandover

    align_center: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
        flex: 1,
        justifyContent: 'space-evenly',
        width: '100%',
        marginTop: '30px',
    },

    // StepStartDate

    align_center4: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: styleColors.lightBeige,
        borderRadius: '20px',
        padding: '20px',
    },
    dateField: {
        [`& fieldset`]: {
            borderRadius: '100px',
        },
    },
    bg_white_borderRadius100: {
        backgroundColor: styleColors.white,
        borderRadius: '100px',
        padding: '18.5px 14px',
    },

    // STepTemplate

    card2: {
        flex: '0 0 auto',
        textAlign: 'center',
        margin: '10px',
    },
    scheduleImage: {
        width: 120,
        height: 75,
        margin: '10px',
    },
    subtitle: {
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
    },
    selectedCard: {
        border: '2px',
        margin: '8px',
        borderStyle: 'dashed',
        borderRadius: '16px',
    },
    align_center5: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px 0',
        overflow: 'hidden',
        maxHeight: 'calc(100vh - 200px)',
    },
    template_container: {
        minHeight: '400px',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    },

    // StepTemplateCustom

    subtitleText: {
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
        color: styleColors.white,
        textAlign: 'center',
        lineHeight: '34px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    dayName: {
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: '16px',
        minHeight: 16,
    },
    card3: {
        borderRadius: 3,
        minHeight: 34,
        overflow: 'hidden',
    },
    text_center_mb15_p8: {
        marginBottom: 15,
        textAlign: 'center',
        padding: '8px',
    },
    parentA: {
        backgroundColor: styleColors.coralRed
    },
    parentB: {
        backgroundColor: styleColors.darkPurple
    },
    template_container2: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gridTemplateRows: '1fr',
        gridColumnGap: '2px',
        gridRowGap: '2px',
    },
});



// WEBPACK FOOTER //
// ./src/components/guide/guide.styles.ts